import React from "react";
import PropTypes from "prop-types";

const NumberField = ({
  id,
  label,
  value,
  min,
  max,
  step,
  placeholder,
  onChange
}) => (
  <label className="number-field" htmlFor={id}>
    <span className="number-field__label">{label}</span>
    <input
      id={id}
      type="number"
      value={value}
      min={min}
      max={max}
      step={step}
      placeholder={placeholder}
      onChange={event => onChange(event.target.value)}
    />
  </label>
);

NumberField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

NumberField.defaultProps = {
  min: undefined,
  max: undefined,
  step: undefined,
  placeholder: ""
};

export default NumberField;
